const LOG_LEVELS = { INFO: 'INFO', ERROR: 'ERROR', WARN: 'WARN', DEBUG: 'DEBUG' };

class Logger {
    log(level, message, meta = {}) {
        if (process.env.NODE_ENV === 'development') {
            const timestamp = new Date().toISOString();
            console.log(`[${timestamp}] [${level}] ${message}`, meta);
        }
        // In production, send to external service (e.g., Sentry, Datadog)
    }

    info(message, meta) { this.log(LOG_LEVELS.INFO, message, meta); }
    error(message, meta) { this.log(LOG_LEVELS.ERROR, message, meta); }
    warn(message, meta) { this.log(LOG_LEVELS.WARN, message, meta); }
    debug(message, meta) { this.log(LOG_LEVELS.DEBUG, message, meta); }
}

export const logger = new Logger();
